var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCourseBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork_33",
    "data-name": "Artwork 33",
    transform: "translate(28 27.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49768",
    "data-name": "Group 49768",
    transform: "translate(-28 -28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28603",
    "data-name": "Rectangle 28603",
    width: 56,
    height: 56,
    rx: 8,
    transform: "translate(0 0.184)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28603",
    "data-name": "Rectangle 28603",
    width: 56,
    height: 56,
    rx: 8,
    transform: "translate(0 0.184)",
    opacity: 0.15,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141453",
    "data-name": "Path 141453",
    d: "M52.367,37.505V8.031A4.031,4.031,0,0,0,48.337,4H8.031A4.031,4.031,0,0,0,4,8.031V48.337a4.031,4.031,0,0,0,4.031,4.031H37.505a3.994,3.994,0,0,0,2.823-1.17L51.2,40.329A3.989,3.989,0,0,0,52.367,37.505Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseBackground);
export default __webpack_public_path__ + "static/media/icon-course-background.6d11b42e848ae4867001f40599444ece.svg";
export { ForwardRef as ReactComponent };